<template>
  <!-- todo: generic card abstraction -->
  <div class="directory-grid">
    <directory-card
      v-for="production in productions"
      :key="production._id"
      :production="production"
      aria-role="button"
      tabindex="0"
      :class="{ cardActive: (activeItem === production._id) }"
      data-entity="producer-dashboard-clickProductionCard"
      @click.native="$emit('dir-item-clicked', production)"
      @dblclick.native="$emit('dir-item-dblclicked', production)"
      @contextmenu.prevent.native="$emit('on-dir-context-menu', { e: $event, payload: production });"
      @dir-item-flagged="$emit('dir-item-flagged', production)"
      @dropdown-menu-item-clicked="dropDownMenuItemClicked($event, production)"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import {
  formatDistance,
  addDays,
} from 'date-fns';

import DirectoryCard from './DirectoryCard.vue';

export default {
  name: 'DirectoryGrid',

  components: {
    DirectoryCard,
  },

  props: {
    items: Array,
    activeItem: [Number, String],
  },

  computed: {
    ...mapGetters(['hasTeams']),

    productions() {
      return this.items.map((item) => ({
        ...item,
        connected: this.isConnected(item),
      }));
    },
  },

  methods: {
    /**
    * Check all screens connected to the given production.
    * If any screen is currently open, then return true.
    * Otherwise return false.
    * @param {Object} production
    * @returns {Boolean}
    */
    isConnected(production) {
      // `screenMap` only contains connected screens,
      // so we just need to check length by production ID
      const { screenMap } = this.$store.state.screens;
      const screens = screenMap[production._id] || [];
      return !!screens.length;
    },

    getDaysUntilDelete(deleted) {
      const now = new Date();
      return deleted ? formatDistance(now, addDays(deleted, 30)) : '30 days';
    },

    dropDownMenuItemClicked({ callbackName, trigger }, item) {
      this.$emit('dropdown-menu-item-clicked', {
        callbackName,
        trigger,
        item,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.directory-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  grid-gap: 2rem;
  align-items: stretch;
}
</style>
